import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './independence.component.html',
  styleUrls: ['./independence.component.scss']
})
export class IndependenceComponent {
  title = 'eunomiaaudit';
}
